"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var processor_exports = {};
__export(processor_exports, {
  MessageProcessor: () => MessageProcessor,
  NotificationContextProcessor: () => NotificationContextProcessor,
  NotificationProcessor: () => NotificationProcessor
});
module.exports = __toCommonJS(processor_exports);
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_utils = require("./utils");
class MessageProcessor {
  static {
    __name(this, "MessageProcessor");
  }
  static create(event, id) {
    const messageId = event.messageId ?? id;
    if (messageId == null) throw new Error("Message id is required");
    return {
      id: messageId,
      cardId: event.cardId,
      type: event.messageType,
      content: event.content,
      extra: event.extra,
      creator: event.socialId,
      created: event.date ?? /* @__PURE__ */ new Date(),
      reactions: {},
      attachments: [],
      threads: []
    };
  }
  static applyPatch(message, patchEvent) {
    return applyPatchEvent(message, patchEvent);
  }
}
class NotificationContextProcessor {
  static {
    __name(this, "NotificationContextProcessor");
  }
  static create(event, id) {
    const contextId = event.contextId ?? id;
    if (contextId == null) {
      throw new Error("Notification context id is required");
    }
    return {
      id: contextId,
      cardId: event.cardId,
      account: event.account,
      lastView: event.lastView,
      lastUpdate: event.lastUpdate,
      lastNotify: event.lastNotify,
      notifications: (0, import_utils.withTotal)([])
    };
  }
  static update(context, event) {
    if (context.account !== event.account || context.id !== event.contextId) return context;
    return {
      ...context,
      lastView: event.updates.lastView ?? context.lastView,
      lastUpdate: event.updates.lastUpdate ?? context.lastUpdate,
      lastNotify: event.updates.lastNotify ?? context.lastNotify
    };
  }
  static remove(context, event) {
    if (context.account !== event.account || context.id !== event.contextId) return context;
    return void 0;
  }
}
class NotificationProcessor {
  static {
    __name(this, "NotificationProcessor");
  }
  static create(event, id) {
    const notificationId = event.notificationId ?? id;
    if (notificationId == null) {
      throw new Error("Notification id is required");
    }
    return {
      id: notificationId,
      cardId: event.cardId,
      contextId: event.contextId,
      account: event.account,
      type: event.notificationType,
      read: event.read,
      content: event.content ?? {},
      created: event.date ?? /* @__PURE__ */ new Date(),
      messageId: event.messageId,
      creator: event.creator,
      blobId: event.blobId
    };
  }
}
function applyPatchEvent(message, event) {
  if (message.cardId !== event.cardId || message.id !== event.messageId) return message;
  const date = event.date ?? /* @__PURE__ */ new Date();
  switch (event.type) {
    case import_communication_sdk_types.MessageEventType.UpdatePatch: {
      if (date.getTime() < (message.modified?.getTime() ?? 0)) {
        return message;
      }
      return {
        ...message,
        modified: date,
        content: event.content ?? message.content,
        extra: event.extra ?? message.extra
      };
    }
    case import_communication_sdk_types.MessageEventType.RemovePatch: {
      return void 0;
    }
    case import_communication_sdk_types.MessageEventType.ReactionPatch:
      return patchReactions(message, event, date);
    case import_communication_sdk_types.MessageEventType.AttachmentPatch:
      return patchAttachments(message, event, date);
    case import_communication_sdk_types.MessageEventType.BlobPatch:
      return patchBlobs(message, event, date);
    case import_communication_sdk_types.MessageEventType.ThreadPatch:
      return patchThread(message, event, date);
  }
  return message;
}
__name(applyPatchEvent, "applyPatchEvent");
function patchReactions(message, event, date) {
  if (event.personUuid == null) return message;
  if (event.operation.opcode === "add") {
    return addReaction(message, event.operation.reaction, event.personUuid, date);
  } else if (event.operation.opcode === "remove") {
    return removeReaction(message, event.operation.reaction, event.personUuid);
  }
  return message;
}
__name(patchReactions, "patchReactions");
function addReaction(message, emoji, creator, created) {
  const emojiData = message.reactions[emoji] ?? [];
  if (emojiData.some((it) => it.person === creator)) return message;
  const data = {
    count: 1,
    person: creator,
    date: created
  };
  message.reactions = {
    ...message.reactions,
    [emoji]: [...emojiData, data]
  };
  return message;
}
__name(addReaction, "addReaction");
function removeReaction(message, emoji, creator) {
  const emojiData = message.reactions[emoji] ?? [];
  if (!emojiData.some((it) => it.person === creator)) return message;
  return {
    ...message,
    reactions: {
      ...message.reactions,
      [emoji]: emojiData.filter((it) => it.person !== creator)
    }
  };
}
__name(removeReaction, "removeReaction");
function patchAttachments(message, event, date) {
  for (const op of event.operations) {
    if (op.opcode === "add") {
      return addAttachments(message, op.attachments, event.socialId, date);
    } else if (op.opcode === "remove") {
      return removeAttachments(message, op.ids);
    } else if (op.opcode === "set") {
      return setAttachments(message, op.attachments, event.socialId, date);
    } else if (op.opcode === "update") {
      return updateAttachments(message, op.attachments, date);
    }
  }
  return message;
}
__name(patchAttachments, "patchAttachments");
function patchBlobs(message, event, date) {
  const operations = [];
  for (const op of event.operations) {
    if (op.opcode === "attach") {
      operations.push({
        opcode: "add",
        attachments: op.blobs.map((it) => ({
          id: it.blobId,
          mimeType: it.mimeType ?? it.mimeType,
          params: it
        }))
      });
    } else if (op.opcode === "detach") {
      operations.push({
        opcode: "remove",
        ids: op.blobIds
      });
    } else if (op.opcode === "set") {
      operations.push({
        opcode: "set",
        attachments: op.blobs.map((it) => ({
          id: it.blobId,
          mimeType: it.mimeType ?? it.mimeType,
          params: it
        }))
      });
    } else if (op.opcode === "update") {
      operations.push({
        opcode: "update",
        attachments: op.blobs.map((it) => ({
          id: it.blobId,
          params: it
        }))
      });
    }
  }
  const ev = {
    type: import_communication_sdk_types.MessageEventType.AttachmentPatch,
    cardId: message.cardId,
    messageId: message.id,
    operations,
    socialId: event.socialId,
    date: event.date
  };
  return patchAttachments(message, ev, date);
}
__name(patchBlobs, "patchBlobs");
function addAttachments(message, data, creator, created) {
  const newAttachments = [];
  for (const attach of data) {
    const isExists = message.attachments.some((it) => it.id === attach.id);
    if (isExists === void 0) continue;
    const attachment = {
      ...attach,
      created,
      creator
    };
    newAttachments.push(attachment);
  }
  if (newAttachments.length === 0) return message;
  return {
    ...message,
    attachments: [...message.attachments, ...newAttachments]
  };
}
__name(addAttachments, "addAttachments");
function updateAttachments(message, updates, date) {
  if (updates.length === 0) return message;
  const updatedAttachments = [];
  for (const attachment of message.attachments) {
    const update = updates.find((it) => it.id === attachment.id);
    if (update === void 0) {
      updatedAttachments.push(attachment);
    } else {
      updatedAttachments.push({
        ...attachment,
        params: {
          ...attachment.params,
          ...update.params
        },
        modified: date.getTime() > (attachment.modified?.getTime() ?? 0) ? date : attachment.modified
      });
    }
  }
  return {
    ...message,
    attachments: updatedAttachments
  };
}
__name(updateAttachments, "updateAttachments");
function removeAttachments(message, ids) {
  const attachments = message.attachments.filter((it) => !ids.includes(it.id));
  if (attachments.length === message.attachments.length) return message;
  return {
    ...message,
    attachments
  };
}
__name(removeAttachments, "removeAttachments");
function setAttachments(message, data, creator, created) {
  if (data.length === 0) return message;
  return {
    ...message,
    attachments: data.map(
      (it) => ({
        ...it,
        created,
        creator
      })
    )
  };
}
__name(setAttachments, "setAttachments");
function patchThread(message, event, date) {
  const { operation } = event;
  if (operation.opcode === "attach") {
    return attachThread(message, operation.threadId, operation.threadType);
  } else if (operation.opcode === "update") {
    return updateThread(message, operation.threadId, operation.update.threadType);
  } else if (operation.opcode === "addReply") {
    if (event.personUuid == null) return message;
    return addReply(message, operation.threadId, event.personUuid, date);
  } else if (operation.opcode === "removeReply") {
    if (event.personUuid == null) return message;
    return removeReply(message, operation.threadId, event.personUuid);
  }
  return message;
}
__name(patchThread, "patchThread");
function attachThread(message, threadId, threadType) {
  if (message.threads.some((thread) => thread.threadId === threadId)) return message;
  return {
    ...message,
    threads: [
      ...message.threads,
      {
        cardId: message.cardId,
        messageId: message.id,
        threadId,
        threadType,
        repliesCount: 0,
        lastReplyDate: void 0,
        repliedPersons: {}
      }
    ]
  };
}
__name(attachThread, "attachThread");
function updateThread(message, threadId, threadType) {
  if (message.threads.length === 0) return message;
  const t = message.threads.find((it) => it.threadId === threadId);
  if (t === void 0) return message;
  return {
    ...message,
    threads: message.threads.map(
      (it) => it.threadId === threadId ? {
        ...it,
        threadType
      } : it
    )
  };
}
__name(updateThread, "updateThread");
function addReply(message, threadId, person, date) {
  if (!message.threads.some((thread) => thread.threadId === threadId)) return message;
  return {
    ...message,
    threads: message.threads.map(
      (it) => it.threadId === threadId ? {
        ...it,
        repliesCount: it.repliesCount + 1,
        lastReplyDate: date.getTime() > (it.lastReplyDate?.getTime() ?? 0) ? date : it.lastReplyDate,
        repliedPersons: {
          ...it.repliedPersons,
          [person]: (it.repliedPersons[person] ?? 0) + 1
        }
      } : it
    )
  };
}
__name(addReply, "addReply");
function removeReply(message, threadId, person) {
  if (!message.threads.some((thread) => thread.threadId === threadId)) return message;
  return {
    ...message,
    threads: message.threads.map(
      (it) => it.threadId === threadId ? {
        ...it,
        repliesCount: Math.max(0, it.repliesCount - 1),
        repliedPersons: {
          ...it.repliedPersons,
          [person]: Math.max(0, (it.repliedPersons[person] ?? 0) - 1)
        }
      } : it
    )
  };
}
__name(removeReply, "removeReply");
//# sourceMappingURL=processor.js.map
